import React, { useEffect } from "react";
import Loader from "../../../SharedComponents/Loader/Loader";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {
  AcceptNumbersandLetters,
  AvoidSpace,
  CatchMessage,
  JSONtoformdata,
} from "../../../Shared/Methods";
import classes from "../Login.module.css";
import CommonButton from "../../../Components/Buttons/CommonButton";
import { useFormik } from "formik";
import * as Yup from "yup";
import CommonInput from "../../../Components/CommonForms/CommonInput";
import { ProjectID, lengths } from "../../../Shared/Constants";
import { handleloading } from "../../../Store/Redux/Reducers/Dashboardreducers";
import { toast } from "react-toastify";
import { frogotpassandorgService } from "../../../Services/ApiServices";

const validation = Yup.object().shape({
  iscodetype: Yup.boolean(),
  organization_code: Yup.string().when("iscodetype", {
    is: (iscodetype: boolean) => {
      return iscodetype;
    },
    then: () => Yup.string().required("Organization Code is required"),
  }),

  email_ph_no: Yup.string()
    .required("E-mail or Mobile Number is required")
    .test("Emailormobilenumber", "Invalid E-mail or Mobile Number", (value) => {
      // Test for email format
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      const isEmail = emailRegex.test(value);

      // Test for mobile number format
      const mobileRegex = /^\d{10}$/;
      const isMobileNumber = mobileRegex.test(value);

      // Return true if either email or mobile number format is valid
      return isEmail || isMobileNumber;
    }),
});

interface formikprops {
  organization_code: string;
  email_ph_no: string;
  iscodetype: boolean;
  type: number;
}

function Forgotpassword() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading } = useSelector((state: any) => state.Dashboard);
  const location = useLocation();
  const { state } = location || {};
  const { codetype, response } = state || {};

  const {
    values,
    errors,
    touched,
    setFieldValue,
    handleSubmit,
    handleBlur,
    setValues,
  } = useFormik({
    initialValues: {
      organization_code: "",
      email_ph_no: "",
      iscodetype: true,
      type: 1,
    },

    validationSchema: validation,
    onSubmit: (value) => {
      handleForgotpassword();
    },
  });

  useEffect(() => {
    if (codetype === 1) {
      setValues({
        ...values,
        iscodetype: false,
        type: 2,
      });
    }
  }, [codetype]);

  const handleForgotpassword = () => {
    dispatch(handleloading(true));

    const finalObj = {
      ...values,
      ...ProjectID,
    };

    const finalData = { ...finalObj } as Partial<formikprops>;
    delete finalData?.iscodetype;

    if (codetype === 1) {
      //call when forgot organization code
      delete finalData?.organization_code;
    }

    frogotpassandorgService(JSONtoformdata(finalData))
      .then((res) => {
        if (res?.data?.status === 1) {
          navigate("/otpverification", {
            state: {
              response: {
                ...res?.data,
                email: values.email_ph_no,
                org_code: values.organization_code,
                frompassword: true,
              },
            },
          });

          toast.success(res?.data?.msg);
        } else if (res?.data?.status === 0) {
          toast.error(res?.data?.msg);
        }
      })
      .catch((err) => {
        CatchMessage(err);
      })
      .finally(() => dispatch(handleloading(false)));
  };

  // useEffect(() => {
  //   const disableBackNavigation = (event: PopStateEvent) => {
  //     event.preventDefault();
  //     // setconfirmation(true);
  //     navigate("/");
  //   };

  //   window.history.pushState(null, "/");
  //   window.addEventListener("popstate", disableBackNavigation);

  //   return () => {
  //     window.removeEventListener("popstate", disableBackNavigation);
  //   };
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  return (
    <>
      <Loader isLoader={loading} />
      <p className={classes.login_text}>
        {codetype === 1 ? "Forgot Organization Code!" : "Forgot password!"}
      </p>

      <form
        onSubmit={handleSubmit}
        className={`primaryInput ${classes.login_form_container}`}
        id="remove_image"
      >
        {/* <div style={{ display: "flex", flexDirection: "column", gap: "15px" }}>
          <img
            className={`img-auto ${classes.appLogo}`}
            src={appLogo}
            alt="appLogo"
          />
          <p className={classes.appText}>M-POWER</p>
        </div> */}
        {/* <p>Login</p> */}
        {codetype === 1 ? null : (
          <CommonInput
            name="organization_code"
            value={values?.organization_code}
            onChange={(e) => {
              if (AcceptNumbersandLetters(e.nativeEvent.data)) {
                setFieldValue("organization_code", e.target.value);
              }
            }}
            required={true}
            error={errors}
            touched={touched}
            labelname={"Organization Code"}
            // onPaste={PreventPasting}
            maxLength={lengths.OrganizationCode}
            onKeyDown={AvoidSpace}
            isInvalid={
              errors.organization_code && touched.organization_code
                ? true
                : false
            }
            onBlur={handleBlur}
            // preIcon={passwordIcon}
            type="text"
            // preIconStyles={{
            //   height: "22px",
            // }}
          />
        )}

        <CommonInput
          name="email_ph_no"
          value={values?.email_ph_no}
          onChange={({ target }) => {
            if (!target.value.includes(" ")) {
              setFieldValue("email_ph_no", target.value);
            }
          }}
          required={true}
          error={errors}
          touched={touched}
          labelname={
            codetype === 1
              ? "Admin E-mail or Mobile Number"
              : "E-mail or Mobile Number"
          }
          // maxLength={lengths.Names}
          onKeyDown={AvoidSpace}
          isInvalid={errors.email_ph_no && touched.email_ph_no ? true : false}
          onBlur={handleBlur}
          type="text"
        />

        <div className={classes.btn_container}>
          <CommonButton
            name="Submit"
            style={{
              border: "none",
              width: "100px",
              height: "38px",
              color: "white",
              borderRadius: "7px",
            }}
            onClick={() => handleSubmit}
            type="submit"
            classname="submit_btn"
          />
        </div>

        <p
          style={{
            textAlign: "center",
            fontWeight: "500",
            color: "#20a2a0",
            cursor: "pointer",
          }}
          onClick={() => navigate("/")}
        >
          Back to Login
        </p>
      </form>
    </>
  );
}

export default Forgotpassword;
